<app-loader></app-loader>
<p-toast [breakpoints]="{ '420px': { width: '100%', right: '0', left: '0' } }"></p-toast>
<div class="search-data">
  <h5 id="tbl-pageTop">Registered drivers</h5>
  <div class="create-booking">
    <ul>
      <li *ngIf="inviteDriverCheck">
        <div class="booking-inner">
          <img src="../../../../assets/images/invite-driver.svg" (click)="InviteDriverModalComponent()" alt="Invite driver"/>
          <span (click)="InviteDriverModalComponent()">Invite Driver</span>
        </div>
      </li>
      <li *ngIf="createDriverCheck">
        <div class="booking-inner" [routerLink]="['/'+roleRoute+'/create-driver']">
          <img src="../../../../assets/images/create-booking.svg" alt="Booking create"/>
          <span>Create Driver</span>
        </div>
      </li>
      <li>
        <div class="booking-inner" (click)="exportData()">
          <img src="../../../../assets/images/export-list.svg" alt="Export list"/>
          <span>Export</span>
        </div>
      </li>
    </ul>
  </div>
</div>
<div class="date-filter">
  <div class="grid">
    <div class="col-12 lg:col-10">
      <div class="grid">
        <div class="col-12 lg:col-3">
          <div class="date-outer">
            <label for="driverName">Driver Name</label>
            <div class="custom-select2">
              <div class="filter-parking header-filter">
                <input id="driverName" type="text" pInputText placeholder="Enter Name" [(ngModel)]="driverName" />
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 lg:col-3">
          <div class="date-outer">
            <label for="driverNumber">Mobile Number</label>
            <div class="custom-select2">
              <div class="filter-parking header-filter">
                <input id="driverNumber" type="text" pInputText placeholder="Enter Mobile Number" [(ngModel)]="driverNumber"
                  (keypress)="onlyNumber($event)" />
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 lg:col-3">
          <div class="date-outer">
            <label for="driverEmail">Driver Email</label>
            <div class="custom-select2">
              <div class="filter-parking header-filter">
                <input id="driverEmail" type="text" pInputText placeholder="Enter Email" [(ngModel)]="driverEmail" />
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 lg:col-3">
          <div class="date-outer">
            <label for="searchStatus">Status</label>
            <div class="custom-select2">
              <div class="filter-parking header-filter">
                <p-dropdown id="searchStatus" [options]="selectStatus" (onChange)="onChangePaymentStatus($event)"
                  placeholder="Select Status" [(ngModel)]="searchStatus" optionLabel="name" optionValue="id"
                  optionValue="value"></p-dropdown>
                <img src="assets/images/fill-dropdown.svg" alt=""/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 lg:col-2">
      <div class="grid list-grid">
        <div class="col-12 lg:col-6">
          <div class="date-outer-btn">
            <div class="edit-outer">
              <p-button styleClass="p-button search-button" label="Search"
                (onClick)="getDriverListCreatedBySuperAdmin('search')"></p-button>

            </div>
          </div>
        </div>
        <div class="col-12 lg:col-6">
          <div class="date-outer-btn">
            <div class="edit-outer reset-btn">
              <p-button styleClass="p-button  p-button-outlined" label="Reset" (onClick)="resetFilter()"></p-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="driver-list-outer">
  <div class="list-heading">
    <h4>Drivers List</h4>
    <div class="page-list filter-parking">
      <p>Show
        <p-dropdown [options]="CustomItemPerPageBy" (onChange)="onDropdownChange($event)" placeholder="10"
          optionLabel="name" optionValue="value" [(ngModel)]="SearchItemPerPageBy"></p-dropdown><img
          src="assets/images/fill-dropdown.svg" alt=""/>
        Records
      </p>
    </div>
  </div>
  <div class="card parking-list" [class.parking-list]="driverList?.length>0">

    <p-table id="tbl-top" [value]="driverList">
      <ng-template pTemplate="header">
        <tr>

          <th scope="col">Driver Name
          <th scope="col" class="custom-addres">Driver Email
          <th scope="col">Mobile Number
          <th scope="col">Created On
          </th>
          <th scope="col">Status
          </th>
          <th scope="col">Action
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData>
        <tr class="border12">
          <td [ngClass]="{'cursor-pointer': viewProfileCheck}"
            (click)="viewProfileCheck? goToDriverInfoPage(rowData) : ''">
            <div class="driver-names"><img [src]="(rowData.profileImagePath)?rowData.profileImagePath:dummy" alt="Profile" /><span>{{
                rowData.driverName
                }}</span></div>
          </td>
          <td>
            <div class="driver-email">{{rowData.email}}</div>
          </td>
          <td>
            <div class="mobile-number"><span [ngClass]="getFlagClass(rowData?.iso)"></span>{{ rowData.countryCode &&
              rowData.mobileNumber ? (rowData.countryCode + ' ' + rowData.mobileNumber) : '-' }}</div>
          </td>
          <td>{{ rowData.dateCreated | customDate1}}</td>

          <td>
            <div class="active-toggle">
              <label [for]="'togBtn_' + rowData.id" class="switch">
                <input type="checkbox" [id]="'togBtn_' + rowData.id" [checked]="rowData.isActive"
                  (change)="activeOrDeactivateDriver(rowData.id)">
                <div class="slider round">
                  <span class="on">Active</span>
                  <span class="off">Inactive</span>
                </div>
              </label>
            </div>
          </td>

<td>
            <div class="export-btn">
              <img (click)="activeItem = rowData;showData(rowData);menu.toggle($event)"
                src="assets/images/dashboard-dot.svg" alt="" />
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage" let-columns>
        <tr class="no-border">
          <td class="no-record" colspan="7">
            No Record Found
          </td>
        </tr>
      </ng-template>

    </p-table>

    <div class="card flex justify-content-end custom-pagination2" *ngIf="driverList?.length > 0">
      <p-paginator [first]="currentSkip" [rows]="itemsPerPage" [totalRecords]="totalDriverRecord"
        (onPageChange)="onPageChange($event)"></p-paginator>
    </div>
  </div>
</div>
<div class="custom-export"> <p-menu #menu [model]="items" [popup]="true"></p-menu>
</div>